import { render, staticRenderFns } from "./AuthoringTool.vue?vue&type=template&id=32998f44&scoped=true&"
import script from "./AuthoringTool.vue?vue&type=script&lang=js&"
export * from "./AuthoringTool.vue?vue&type=script&lang=js&"
import style0 from "./AuthoringTool.vue?vue&type=style&index=0&id=32998f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32998f44",
  null
  
)

export default component.exports